
import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LeadAccount, StrategyWithDetails } from "@/types/strategy-types";

interface AccountStrategyFieldsProps {
  form: UseFormReturn<any>;
  filteredStrategies: StrategyWithDetails[];
  filteredLeadAccounts: LeadAccount[];
}

const AccountStrategyFields = ({ 
  form, 
  filteredStrategies, 
  filteredLeadAccounts 
}: AccountStrategyFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="strategy_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="strategy_id">Strategy</FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger id="strategy_id" name="strategy_id">
                  <SelectValue placeholder="Select strategy" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {filteredStrategies.map((strategy) => (
                  <SelectItem key={strategy.id} value={strategy.id}>
                    {strategy.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="lead_account_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="lead_account_id">Lead Account</FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger id="lead_account_id" name="lead_account_id">
                  <SelectValue placeholder="Select lead account" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {filteredLeadAccounts.map((account) => (
                  <SelectItem key={account.id} value={account.id}>
                    {account.external_id} ({account.exchange})
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />
    </div>
  );
};

export default AccountStrategyFields;
